/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import { ExpandCollapse } from '@tds/core-expand-collapse';
import FormSummaryRow from '../formSummaryRow';
import { GroupWrapper, GroupTitle } from '../css';
import {
  BACKEND_KEYS,
  additionalEquipment,
  easyAdditionalEquipment,
  oneTimeAdditionalEquipment,
  fieldWinbackFibre,
  valueNewTelusBusinessOrder,
  fieldWinback,
  fieldAddProductVulcan,
  fieldBusinessConnectVulcan,
  isCouponBasedDiscountField
} from '../../utils/constant';

import { getLocalizedStrings, getLocale } from '../../misc';
import { get } from 'lodash';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import CodeBasedPromotions from './components/codeBasedPromotions';

const userDetailsKey = 'userDetails';
const formSectionKey = 'formSection';
const repeatedFormKey = 'repeatedForm';
const formFieldsGroup = 'formFieldsGroup';

const removePrice = label => {
  if (!label || typeof label !== 'string') return label;
  return label.replace(/\([\D\s]*\$[\d.\s\D]*\)/g, '');
};

const priceClean = label => {
  if (Array.isArray(label)) {
    return label.map(filteredLabel => {
      return removePrice(filteredLabel);
    });
  }
  return removePrice(label);
};

export const getFieldLabel = (options, fieldValue) => {
  if (!options || !options.length) {
    if (Array.isArray(fieldValue)) {
      return (
        fieldValue &&
        fieldValue.length > 0 &&
        fieldValue.map(field => priceClean(field))
      );
    }
    return priceClean(fieldValue);
  }
  for (let i = 0; i < options.length; i += 1) {
    const option = options[i];
    const fields = option.fields || {};
    const { label, value } = fields || {};
    if (value === fieldValue) {
      return priceClean(label);
    }
  }

  if (Array.isArray(fieldValue) && fieldValue.length === 0) {
    return null;
  }
  return priceClean(fieldValue);
};

const VulcanOrderSummary = ({ stepData, orderData }) => {
  if (!Array.isArray(stepData)) {
    return null;
  }
  const locale = getLocale();
  const {
    vulcanWebform: {
      businessWifiVul,
      vulBusinessWifi,
      vulFibreInternet,
      vulBusinessConnect,
      vulTSB
    }
  } = locale === 'en-US' ? EN : FR;
  const stepSummaryData = stepData.slice(0, 3);
  const productName = get(orderData, fieldAddProductVulcan, []);
  const orderIdTSBValue = get(orderData, 'orderIdTSB', '');
  const isCouponBasedDiscountValue = get(orderData, isCouponBasedDiscountField, '')
  const isProductVisible = (name, productName) => {
    if (
      name === 'Fibre Internet' &&
      productName.includes(vulFibreInternet) 
    ) {
      return true;
    }

    if (
      name === 'secureBusinessProductVulcan' &&
      productName.includes(vulTSB) &&
      !orderIdTSBValue
    ) {
      return true;
    }

    if (name === 'Business Wi-Fi' && productName.includes(vulBusinessWifi)) {
      return true;
    }

    if (name === 'customerInformationVulcan') {
      return true;
    }

    if (name === 'couponBasedDiscounts' && isCouponBasedDiscountValue === yes) {
      return true;
    }

    return false;
  };

  const isSectionVisisble = stepBackendKey => {
    if (
      stepBackendKey === ' additionalCustomerInformation' &&
      (productName.includes(vulBusinessConnect) || orderIdTSBValue)
    ) {
      return false;
    }
    return true;
  };
  const {
    contentfulValues: { yes, no }
  } = getLocalizedStrings();

  // Function to handle boolean values
  const handleBooleanValue = value => {
    return value ? yes : no;
  };

  // Function to handle field values
  const handleFieldValue = (backendKey, value) => {
    if (typeof value === 'boolean') {
      return handleBooleanValue(value);
    }
    return value;
  };

  const groupSummary = (
    fieldNamesArray,
    formStepFieldsArray,
    groupOrderData
  ) => {
    return formStepFieldsArray.map((formStepFields, index) => {
      if (!formStepFields) return null;
      const nonEmptyFields =
        formStepFields &&
        formStepFields.filter(currentField => {
          const {
            fields: { backendKey }
          } = currentField || {};
          const isObject = typeof groupOrderData[backendKey] === 'object';
          const isArray = Array.isArray(groupOrderData[backendKey]);
          if (isObject && !isArray) {
            return !!groupOrderData[backendKey].value;
          }
          if (isArray && groupOrderData[backendKey].length) {
            return true;
          }
          return !!groupOrderData[backendKey];
        });

      if (!nonEmptyFields || !nonEmptyFields.length) return null;
      const setTitle = label => {
        if (label === additionalEquipment) {
          return `${label} (${oneTimeAdditionalEquipment})`;
        }
        if (label === easyAdditionalEquipment) {
          return `${additionalEquipment} (${label})`;
        }
        return label;
      };
      return (
        <GroupWrapper key={index} style={{ marginBottom: '1em' }}>
          <GroupTitle style={{ marginBottom: '0.5em' }}>
            {setTitle(fieldNamesArray[index])}
          </GroupTitle>
          {nonEmptyFields &&
            nonEmptyFields.map(({ fields: { backendKey, label, options } }) => {
              let fieldValue = '';
              const isArray = Array.isArray(groupOrderData[backendKey]);
              const isObject = typeof groupOrderData[backendKey] === 'object';
              if (isObject && !isArray) {
                fieldValue = priceClean(groupOrderData[backendKey].value);
              } else if (isArray) {
                fieldValue = groupOrderData[backendKey]
                  .join(', ')
                  .split(',')
                  .map(item => priceClean(item))
                  .join(',');
              } else {
                fieldValue = priceClean(groupOrderData[backendKey]);
              }
              fieldValue = handleFieldValue(backendKey, fieldValue);
              const labelLogic =
                fieldNamesArray[index] &&
                fieldNamesArray[index] === additionalEquipment
                  ? priceClean(label)
                  : priceClean(label);
              return (
                <FormSummaryRow
                  key={backendKey}
                  label={labelLogic}
                  value={getFieldLabel(options, fieldValue)}
                  isDollarRemove
                />
              );
            })}
        </GroupWrapper>
      );
    });
  };

  const handleFormSummaryRow = (
    {
      fieldLabel,
      fieldBackendKey,
      fieldName,
      formStepFields,
      contentfulId,
      formTitle,
      options: mainOptions,
      appearsAfterValue,
      appearsAfterField,
      easyPaymentFields,
      easyPaymentTitle
    },
    customOrderData
  ) => {
    const dataOrder = customOrderData || orderData;

    if (
      (fieldName === fieldWinbackFibre || fieldName === fieldWinback) &&
      dataOrder.orderType !== valueNewTelusBusinessOrder
    )
      return null;
    if (contentfulId === userDetailsKey) {
      return groupSummary([fieldName], [formStepFields], dataOrder);
    }
    if (contentfulId === formFieldsGroup) {
      return groupSummary([fieldName], [formStepFields], dataOrder);
    }
    if (contentfulId === formSectionKey) {
      return (
        formStepFields &&
        formStepFields.length > 0 &&
        formStepFields.map(item => {
          const {
            fields: {
              label,
              backendKey,
              name: sectionFieldName,
              fields: groupFields,
              formFields: sectionFormFields,
              title,
              formTitle: sectionFormTitle
            },
            sys: {
              contentType: {
                sys: { id: fieldContentfulId }
              }
            }
          } = item || {};
          const rowObj = {
            fieldLabel: label,
            fieldBackendKey: backendKey,
            fieldName: sectionFieldName || title,
            formStepFields: groupFields || sectionFormFields,
            contentfulId: fieldContentfulId,
            formTitle: title || sectionFormTitle
          };
          return handleFormSummaryRow(rowObj, customOrderData);
        })
      );
    }
    if (contentfulId === repeatedFormKey) {
      return (
        dataOrder[fieldName] &&
        dataOrder[fieldName].map((row, idx) =>
          groupSummary([`${formTitle} ${idx + 1}`], [formStepFields], row)
        )
      );
    }
    const fieldKey =
      (dataOrder[fieldBackendKey] && fieldBackendKey) || fieldName;
    let fieldValue = getFieldLabel(mainOptions, dataOrder[fieldKey]);

    // Check if the type can be converted to float
    let typeCheckedFieldValue = parseFloat(fieldValue);

    // Check if the value really is in decimals and needs rounding off
    if (typeCheckedFieldValue && typeCheckedFieldValue % 1 !== 0) {
      typeCheckedFieldValue = typeCheckedFieldValue.toFixed(2);
    } else if (typeof fieldValue === 'boolean') {
      typeCheckedFieldValue = handleBooleanValue(fieldValue);
    } else {
      typeCheckedFieldValue = fieldValue;
    }

    return (
      <FormSummaryRow
        key={fieldBackendKey}
        label={fieldLabel}
        value={typeCheckedFieldValue}
        isDollarRemove
      />
    );
  };

  const rowCb = (formStepFields, customOrderData) => {
    return formStepFields.map(formStepField => {
      const {
        fields: {
          label: fieldLabel,
          outputLabel,
          backendKey: fieldBackendKey,
          formStepFields: subStepFields,
          easyPaymentFields,
          easyPaymentTitle,
          formFields: repeatedGroupFields,
          appearsAfterField,
          appearsAfterValue,
          fields: groupFields,
          name: fieldName,
          title: groupTitle,
          formTitle,
          options
        },
        sys: {
          contentType: {
            sys: { id: contentfulId }
          }
        }
      } = formStepField;
      const isValidRow = contentfulId !== 'equipmentGroupSection';
      return (
        <React.Fragment key={fieldBackendKey}>
          {isValidRow &&
            handleFormSummaryRow(
              {
                fieldLabel: outputLabel || fieldLabel,
                fieldBackendKey,
                formStepFields:
                  subStepFields ||
                  repeatedGroupFields ||
                  groupFields ||
                  formStepFields,
                fieldName: fieldName || groupTitle,
                contentfulId,
                formTitle: formTitle || groupTitle,
                options,
                appearsAfterField,
                appearsAfterValue,
                easyPaymentFields,
                easyPaymentTitle
              },
              customOrderData,
              formStepFields
            )}
        </React.Fragment>
      );
    });
  };

  const handelQuotePage = formStepFields => {
    return formStepFields.map(
      ({ fields: { title: title, name: name, formFields } }) =>
        [
          'customerInformationVulcan',
          'Fibre Internet',
          'Business Wi-Fi',
          'secureBusinessProductVulcan',
          'couponBasedDiscounts'
        ].includes(name) &&
        isProductVisible(name, productName) &&
        (name === 'couponBasedDiscounts' ? (
          <ExpandCollapse.Panel id={name} header={title} key={name}>
            <CodeBasedPromotions orderData={orderData} />
          </ExpandCollapse.Panel>
        ) : (
          <ExpandCollapse.Panel id={name} header={title} key={name}>
            {formFields && rowCb(formFields)}
          </ExpandCollapse.Panel>
        ))
    );
  };

  return (
    <>
      <ExpandCollapse tag="h2">
        {stepSummaryData &&
          stepSummaryData.map(
            ({
              fields: {
                name: stepName,
                backendKey: stepBackendKey,
                formStepFields
              }
            }) =>
              stepBackendKey !== 'quoteVulcan'
                ? isSectionVisisble(stepBackendKey) && (
                    <ExpandCollapse.Panel
                      id={stepBackendKey}
                      header={stepName}
                      key={stepBackendKey}
                    >
                      {rowCb(formStepFields[0].fields.formFields)}
                    </ExpandCollapse.Panel>
                  )
                : handelQuotePage(formStepFields)
          )}
      </ExpandCollapse>
    </>
  );
};

VulcanOrderSummary.propTypes = {
  stepData: PropTypes.objectOf(PropTypes.any).isRequired,
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  isQuestionVisible: PropTypes.bool.isRequired
};

export default VulcanOrderSummary;
